import React, { useState } from 'react';
import StripePayment from './StripePayment';
import './PaymentView.css';

const PaymentTest: React.FC = () => {
    const [testOrderId] = useState('test-order-' + Date.now());
    const [activeTest, setActiveTest] = useState<'stripe' | null>(null);
    const [testClientSecret] = useState('test_secret_' + Date.now());
    const [testPublishableKey] = useState('pk_test_...');

    const handlePaymentComplete = () => {
        console.log('✅ Payment completed successfully');
        alert('Payment completed! (Test mode)');
    };

    return (
        <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>🧪 Payment Integration Test Page</h1>
            <p style={{ color: '#666', marginBottom: '30px' }}>
                Use this page to test Stripe payment integration in isolation.
            </p>

            <div style={{
                padding: '20px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                marginBottom: '30px'
            }}>
                <h3>Test Order Details</h3>
                <p><strong>Order ID:</strong> {testOrderId}</p>
                <p><strong>Amount:</strong> £10.00</p>
                <p><strong>Currency:</strong> GBP</p>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginBottom: '30px', flexWrap: 'wrap' }}>
                <button
                    onClick={() => setActiveTest('stripe')}
                    style={{
                        padding: '12px 24px',
                        fontSize: '16px',
                        backgroundColor: '#635BFF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                    disabled={activeTest === 'stripe'}
                >
                    Test Stripe
                </button>

                <button
                    onClick={() => setActiveTest(null)}
                    style={{
                        padding: '12px 24px',
                        fontSize: '16px',
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    Clear
                </button>
            </div>

            <hr style={{ margin: '30px 0' }} />

            {activeTest === 'stripe' && (
                <div style={{
                    padding: '30px',
                    border: '2px solid #635BFF',
                    borderRadius: '8px',
                    backgroundColor: '#fff'
                }}>
                    <h2>Stripe Payment Test</h2>
                    <p style={{ color: '#666', marginBottom: '20px' }}>
                        This will load the Stripe SDK and embedded checkout.
                        Note: Requires valid client secret from your backend.
                    </p>
                    <StripePayment
                        clientSecret={testClientSecret}
                        publishableKey={testPublishableKey}
                        orderId={testOrderId}
                        amount={10.00}
                        currency="GBP"
                        isActive={true}
                        onPaymentComplete={handlePaymentComplete}
                    />
                </div>
            )}

            {!activeTest && (
                <div style={{
                    padding: '60px',
                    textAlign: 'center',
                    color: '#999',
                    border: '2px dashed #ddd',
                    borderRadius: '8px'
                }}>
                    <p style={{ fontSize: '18px', marginBottom: '10px' }}>
                        👆 Click "Test Stripe" to begin
                    </p>
                    <p>
                        This test page uses a mock client secret.
                        To test real payments, create an order from the main page.
                    </p>
                </div>
            )}

            <hr style={{ margin: '40px 0' }} />

            <div style={{ fontSize: '14px', color: '#666' }}>
                <h3>Instructions:</h3>
                <ol>
                    <li><strong>Test Stripe:</strong> Load Stripe embedded checkout with test credentials</li>
                    <li><strong>Check Console:</strong> Open browser console (F12) to see detailed logs</li>
                    <li><strong>Real Testing:</strong> To test with real payment intents, place an order from the main ordering page</li>
                </ol>

                <h3 style={{ marginTop: '30px' }}>Payment Methods Supported by Stripe:</h3>
                <ul>
                    <li><strong>Credit/Debit Cards:</strong> Visa, Mastercard, American Express, etc.</li>
                    <li><strong>Apple Pay:</strong> Available on Safari with configured Apple Pay</li>
                    <li><strong>Google Pay:</strong> Available on supported browsers with Google Pay setup</li>
                </ul>

                <h3 style={{ marginTop: '30px' }}>Common Issues:</h3>
                <ul>
                    <li>If checkout doesn't appear: Verify Stripe publishable key and client secret are valid</li>
                    <li>If payment fails: Check that your Stripe account is properly configured</li>
                    <li>For Apple Pay/Google Pay: These are handled automatically by Stripe's checkout</li>
                </ul>
            </div>
        </div>
    );
};

export default PaymentTest;
